import { api } from 'cssapi'
import styled from 'styled-components'
import TextLink from './TextLink'

const ContentLink = styled(TextLink)`
  ::before {
    content: '';
    position: absolute;
    transition: all 1s ease-in-out;
    z-index: -2;

    ${api({
      bottom: 0,
      top: 0,
      left: `-4%`,
      right: `-4%`,
    })};
  }
`

export default ContentLink



// WEBPACK FOOTER //
// ./src/components/shared/links/ContentLink.jsx